export class UpdateOrganizationStatus {
  statusDay: number;
  statusId: number;
  delay: string;
  delay2: string;

  constructor(json?: any) {
    if (!json) {
      return;
    }

    this.statusDay = json.statusDay;
    this.statusId = json.statusId;
    this.delay = json.delay;
    this.delay2 = json.delay2;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/UpdateOrganizationStatus.ts